/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum LoginAliases {
  BUTTON_0 = 'button-0',
  LAYOUT_0 = 'layout-0',
  LOGIN_COMPONENT = 'login-component',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_NEW_USER = 'panel-new-user',
  SOCIAL_NETWORKS = 'social-networks',
  TEXT_EMAIL = 'text-email',
  TEXT_INFO = 'text-info',
  TEXT_TELEPHONE = 'text-telephone',
}
export { LoginAliases };
